import { IXactimateToolRowData } from "../../../../../shared/common/Azure";

export const SectionHeader = ({ label, count, status }: { label: string; count: number; status: "good" | "bad" }) => (
  <div className={`flex items-center gap-2 font-semibold text-sm mb-2 ${status === "good" ? "text-green-700" : "text-red-700"}`}>
    <span>
      {label} ({count})
    </span>
  </div>
);

export const XactimateBadge = ({ mapping }: { mapping: IXactimateToolRowData }) => (
  <div className="flex gap-2 text-xs text-stone-500 flex-wrap">
    {mapping.cat && <span className="bg-stone-100 rounded px-1 py-0.5">{mapping.cat}</span>}
    {mapping.variable && <span className="bg-stone-100 rounded px-1 py-0.5">{mapping.variable}</span>}
    {mapping.activity && <span className="bg-stone-100 rounded px-1 py-0.5">{mapping.activity}</span>}
    {mapping.quantity && <span className="bg-stone-100 rounded px-1 py-0.5">{mapping.quantity}</span>}
  </div>
);
